import { Component } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { GenericCrudAddComponent } from 'src/app/libs/components/generic-crud/generic-crud-add.component';
import { ProductWarehouseSeasonality } from 'src/app/models';
import { CompanySeasonalitiesAddComponent } from 'src/app/routes/admin/admin-companies/components/company-seasonalities-add/company-seasonalities-add.component';
import { WmsWarehousesAddComponent } from 'src/app/routes/wms/wms-operative/wms-locations/wms-warehouses-add/wms-warehouses-add.component';

@Component({
    selector: 'app-products-warehouses-add',
    templateUrl: './products-warehouses-add.component.html',
    styleUrl: './products-warehouses-add.component.sass',
    standalone: false
})
export class ProductsWarehousesAddComponent extends GenericCrudAddComponent<ProductWarehouseSeasonality> {
  warehouses = this.api.resources.wms.warehouses;
  seasonalities = this.api.resources.master.companySeasonalities(this.api.auth.userValue!.lastCompanyId);

  createWarehouseComponent = WmsWarehousesAddComponent;
  addSeasonality = CompanySeasonalitiesAddComponent;

  protected override async preFetch(): Promise<void> {
    this.seasonalities = this.api.resources.master.companySeasonalities(this.api.auth!.userValue!.lastCompanyId!);
  }

  override initFormGroup(): FormGroup<any> {
    const group = this.fb.group({
      warehouseId: [undefined],
      seasonalityId: [undefined],
      minStock: [undefined],
      maxStock: [undefined],
      securityStock: [undefined],
      optimalOrderAmount: [undefined],
    });
    return group;
  }
}
